import {
  Box,
  chakra,
  shouldForwardProp,
  useColorModeValue
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useIsLandScapeMachine from '@/hook/useIsLandScapeMachine';
import useLongMachineSetting from '@/hook/useLongMachineSetting';

import GameCatalog from '../../components/GameCatalog/GameCatalog';
import useCheckLogin from '../../hook/useCheckLogin';
import useDeviceType from '../../hook/useDeviceType';
import { toggleBGM } from '../../redux/action/action';
import {
  closeFullScreen,
  openFullScreen
} from '../../redux/action/game/gameAction';
import { getRandomSlice } from '../../utils/shuffle';
import AlertInvalidBetButton from './components/AlertInvalidBetButton';
import GameBoxHeader from './components/gameBoxHeader';
import VipBar from './components/vipBar';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const GameWrap = ({ children }) => {
  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);
  const isVipBarOpen = useSelector((state) => state.isVipBar);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const gameConfig = useSelector((state) => state.isGameConfig);

  const { topGameList } = isHandleAllGame;

  const vipBarBg = useColorModeValue('light.200', 'dark.200');

  const topGameRandom = useMemo(() => {
    return getRandomSlice(topGameList);
  }, [gameConfig]);

  const dispatch = useDispatch();

  const deviceType = useDeviceType();

  const { isMachineUser } = useCheckLogin();

  const isMachineLandscape = useIsLandScapeMachine();

  const { longMachineVideoHeight } = useLongMachineSetting();

  const isVerticalGame = gameConfig?.support_vertical === 1;

  //改為 機台使用者 在載入時 預設打開全螢幕  否則預設關閉全螢幕
  useEffect(() => {
    if (isMachineUser || deviceType == 'PC') {
      dispatch(openFullScreen());
    } else {
      dispatch(closeFullScreen());
    }
  }, [isMachineUser, deviceType]);

  useEffect(() => {
    dispatch(
      toggleBGM({
        enabled: false,
        song: 'back2_',
        musicVolume: 0.2
      })
    );
  }, []);

  return deviceType === 'PC' || deviceType === 'Tablet' ? (
    <>
      <Box
        as="section"
        pt={{
          md: isOpenFullScreen ? '0px' : '30px'
        }}
        mb={{
          xl: '0px',
          md: '20px'
        }}
        position={`${isOpenFullScreen ? 'fixed' : 'relative'}`}
        top={
          isMachineLandscape
            ? isVerticalGame
              ? '0'
              : longMachineVideoHeight
            : '0px'
        }
        h={
          isMachineLandscape
            ? isVerticalGame
              ? '100%'
              : `calc(100dvh - ${longMachineVideoHeight})`
            : isOpenFullScreen
              ? '100%'
              : ''
        }
        left="0px"
        w={isOpenFullScreen ? '100%' : ''}
        zIndex={`${isOpenFullScreen ? '1100' : '0'}`}
      >
        <Box
          as="section"
          w={{
            lg: isOpenFullScreen ? '' : '820px',
            xl: isVipBarOpen ? '100%' : isOpenFullScreen ? '' : '1128px'
          }}
          h={isOpenFullScreen ? '100%' : '588px'}
          display={`flex`}
          mx="auto"
          borderBottomRadius={isOpenFullScreen ? '0' : 'common'}
          borderTopRadius={isOpenFullScreen ? '0' : '5px'}
          overflow="hidden"
        >
          <Box
            display="flex"
            flexDirection={'column'}
            as="section"
            w={isVipBarOpen ? 'calc(100% - 280px)' : '100%'}
          >
            <GameBoxHeader />
            {children}
            <AlertInvalidBetButton />
          </Box>
          {isVipBarOpen && (
            <ChakraBox
              as="section"
              w="280px"
              overflowY={{
                md: 'scroll'
              }}
              bg={vipBarBg}
              className={`no-scrollbar`}
            >
              <VipBar />
            </ChakraBox>
          )}
        </Box>
        <Box mx="auto" p="10px">
          {/* <UserClickGameCatalog /> */}
          <GameCatalog
            wrapperClassName={`!my-0`}
            list={topGameRandom}
            mainTitle={`Top`}
            swiperProps={{
              customPerView: 'game-box-layout'
            }}
            hiddenButtonNavigator
          />
        </Box>
      </Box>
    </>
  ) : (
    children
  );
};

export default GameWrap;
